import FeaturesModal from './FeaturesModal';

export default FeaturesModal;
